import { useFormContext } from 'react-hook-form';
import {
  RadioControl,
  RadioOptions,
} from '../../../page-builder/components/form-fields/Radio';
import { AddressForm } from './AddressForm';
import { ComponentConfig } from '@measured/puck';
import {
  MarginProps,
  marginFields,
} from '../../../page-builder/puck/reusable-props/margin';
import CustomTooltip from '../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../services/constants';
import { IFieldOption } from '../../interface/formInterface';
import { PlaceHolderField } from '../../puck/reusable-props/placeHolder';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
} from '../../utils/helper';
import { FormData } from '../../../page-builder/interface/checkoutInterface';
import AddressHelper from './AddressHelper';
import {
  paddingFields,
  paddingProps,
  PaddingProps,
} from '../../puck/reusable-props/padding';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { backgroungFields } from '../../puck/reusable-props/backgroungFields';
import {
  fieldHeightProps,
  inputFieldHeightProps,
} from '../../puck/reusable-props/inputfield-height';
import ColorPicker from '../../puck/reusable-props/ColorPicker';
import SelectedOptionCustomization, {
  ISelectedOptionCustomizationProps,
} from './billingFormFields/SelectedOptionCustomization';
import { defaultBorderProps } from '../../utils/constants';
import { getIsViewIsEdit } from '../../utils/constants';
import { marginProps } from '../../puck/reusable-props/NewMargin';
import { outlineProps } from '../../puck/reusable-props/Outline';
// import { getIsViewIsEdit } from '../../utils/constants';

export type BillingFormProps = {
  placeholder: {
    header: string;
    same: string;
    different: string;
  };
  background: {
    color: string;
    isInherit: boolean;
  };
  option: IFieldOption;
  radioColor: string;
  radioSize: string;
  border: IBorderValueProps;
  selectedOptionCustomization: ISelectedOptionCustomizationProps;
} & MarginProps &
  fieldHeightProps &
  PaddingProps;

export const BillingForm = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<BillingFormProps> => {
  return {
    label: (
      <CustomTooltip title="BillingForm">
        <span>Billing Form</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...marginFields,
      ...paddingFields,
      ...backgroungFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      placeholder: {
        type: 'custom',
        label: 'Place Holder',
        render: ({ value, onChange }) => {
          return (
            <PlaceHolderField
              name="quill"
              value={value}
              onChange={onChange}
              data={[
                { label: 'Same', value: 'same' },
                { label: 'Different', value: 'different' },
                { label: 'Header', value: 'header' },
              ]}
            />
          );
        },
      },
      radioColor: {
        type: 'custom',
        label: 'Selected radio color',
        render: ({ value, onChange, field }) => (
          <ColorPicker
            value={value}
            onChange={onChange}
            label={field.label}
            tooltip={field.label}
          />
        ),
      },
      radioSize: {
        type: 'custom',
        label: 'Radio Size',
        render: ({ value, onChange }) => (
          <>
            <label>Radio Size</label>
            <input
              type="Number"
              value={value || ''}
              onChange={newValue => {
                onChange(newValue.target.value);
              }}
            />
          </>
        ),
      },

      ...inputFieldHeightProps(),
      option: {
        type: 'custom',
        label: 'Options',
        render: ({ value, onChange }) => {
          return (
            <AddressHelper
              value={value}
              onChange={onChange}
              name={`Billing Form`}
            />
          );
        },
      },
      selectedOptionCustomization: {
        type: 'custom',
        render: ({ value, onChange }) => {
          return (
            <SelectedOptionCustomization value={value} onChange={onChange} />
          );
        },
      },
    },
    defaultProps: {
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      radioColor: '#4f46e5',
      radioSize: '16',
      heightField: {
        height: {
          desktop: '42',
          tablet: '42',
          mobile: '42',
        },
        rowGap: {
          mobile: '10',
          tablet: '10',
          desktop: '10',
        },
        colGap: {
          mobile: '10',
          tablet: '10',
          desktop: '10',
        },
        deviceType: 'desktop',
      },
      ...paddingProps,
      ...borderProps,
      selectedOptionCustomization: {
        background: {
          color: '#FFFFFF',
          isInherit: true,
        },
        borderColor: '#ccc',
      },
      placeholder: {
        header:
          '<p style="line-height:1.43;"><span style="font-size: 14px;">Specify the address for your payment option</span></p>',
        same: '<p style="line-height:1.43;"><span style="font-size: 14px;">Same as shipping address</span></p>',
        different:
          '<p style="line-height:1.43;"><span style="font-size: 14px;">Use a different billing address</span></p>',
      },
      option: {
        FirstName: {
          header: {
            hide: false,
            text: 'First Name',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'First Name',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'First Name is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        LastName: {
          header: {
            hide: false,
            text: 'Last Name',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Last Name',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'Last Name is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        Address1: {
          header: {
            hide: false,
            text: 'Address',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Address',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'Address is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        Address2: {
          header: {
            hide: true,
            text: 'Address 2',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Apartment, suite, etc. (optional)',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: false,
          validationText: '',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        City: {
          header: {
            hide: false,
            text: 'City',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'City',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'City is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        CountryCode: {
          header: {
            hide: false,
            text: 'Country',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Select',
          showOnlyCountry: [],
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'Country is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        ProvinceCode: {
          header: {
            hide: false,
            text: 'State / Province',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Select State / Province',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: false,
          validationText: '',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        Organization: {
          header: {
            hide: true,
            text: 'Company',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Company (optional)',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: false,
          validationText: '',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
        // Phone: {
        //   placeholder: 'Phone Number',
        //   defaultPhoneCode: '',
        //   show: true,
        //   border: {
        //     borderTopLeft: '6',
        //     borderTopRight: '6',
        //     borderBottomLeft: '6',
        //     borderBottomRight: '6',
        //   },
        //   requiredValidation: true,
        //   validationText: 'Phone number is required',
        //   color: '#808080',
        //   fontSize: '14',
        //   fontWeight: '300',
        //   lineHeight: '1.5',
        //   textAlign: 'left',
        //   fontFamily: 'sans-serif',
        //   letterSpace: '0',
        // },
        Zip: {
          header: {
            hide: false,
            text: 'Postal Code',
            ...paddingProps,
            ...marginProps,
          },
          placeholder: 'Postal code',
          show: true,
          textColor: {
            color: '#000000',
            isInherit: false,
          },
          textBackgroundColor: {
            color: '#ffffff',
            isInherit: false,
          },
          ...defaultBorderProps,
          requiredValidation: true,
          validationText: 'Postal code is required',
          color: '#808080',
          fontSize: '14',
          fontWeight: '300',
          lineHeight: '1.5',
          textAlign: 'left',
          fontFamily: 'sans-serif',
          letterSpace: '0',
          ...outlineProps,
        },
      },
      background: {
        color: '#FFFFFF',
        isInherit: false,
      },
    },
    render: ({
      margin,
      placeholder,
      option,
      background,
      editMode,
      heightField,
      padding,
      radioColor,
      radioSize,
      border,
      selectedOptionCustomization,
    }) => {
      const { watch, setValue } = useFormContext<FormData>();

      if (
        (getIsViewIsEdit() &&
          option?.CountryCode?.defaultCountry?.length &&
          watch('BillingAddress.CountryCode') !==
            option?.CountryCode?.defaultCountry) ||
        (watch('BillingAddress.CountryCode').length == 0 &&
          option?.CountryCode?.defaultCountry?.length &&
          option?.CountryCode?.defaultCountry?.length > 0 &&
          !watch('billing_same_as_shipping'))
      ) {
        setValue(
          'BillingAddress.CountryCode',
          option?.CountryCode?.defaultCountry,
        );
      }
      const addressOptions: RadioOptions[] = [
        { id: '1', name: placeholder?.same, value: true },
        { id: '2', name: placeholder?.different, value: false },
      ];
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const storeData = useAppSelector(state => state.store.storeData);
      const { cartData } = useAppSelector(state => state.cart);
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      return (
        <>
          <div
            className={`${border?.borderStyle?.[currentDeviceType]} text-editor-content`}
            style={{
              ...getPaddingStyles(padding, currentDeviceType),
              ...getBorderProps(border, currentDeviceType),
              ...marginStyles,
            }}>
            <RadioControl
              name="billing_same_as_shipping"
              options={addressOptions}
              radioColor={radioColor}
              placeHolder={placeholder}
              background={background}
              selectedOptionCustomization={selectedOptionCustomization}
              currentDeviceType={currentDeviceType}
              radioSize={radioSize}
            />

            {!watch('billing_same_as_shipping') && (
              <div className="mt-10">
                <AddressForm
                  key="billing-address-form"
                  fieldPrefix="BillingAddress"
                  useAppSelector={useAppSelector}
                  storeData={storeData}
                  cartData={cartData}
                  option={option}
                  currentDeviceType={currentDeviceType}
                  fieldHeight={heightField?.height?.[currentDeviceType]}
                  rowGap={heightField?.rowGap?.[currentDeviceType]}
                  colGap={heightField?.colGap?.[currentDeviceType]}
                />
              </div>
            )}
          </div>
        </>
      );
    },
  };
};
